/**
 * 実行環境関連 Class
 */
export default class Environment {
	/**
	 * デバイスタイプ判定
	 * @returns {string}
	 */
	static getDeviceType() {
		let deviceType = 'pc';
		let windowW = window.outerWidth;
		if (750 >= windowW) {
			deviceType = 'sp'
		}
		return deviceType
	};

	/**
	 * ヘッダー高さ取得
	 * @returns {number}
	 */
	static getHeaderH() {
		let headerH = $('.l-header').outerHeight();
		return headerH;
	};

	/**
	 * トップ階層URL取得
	 * @returns {string}
	 */
	static getHomeUrl() {
		let homeUrl = '';
		let protocol = location.protocol;
		let host = location.host;
		if (host == 'www.trn-g.jp') {
			homeUrl = protocol + '//' + host + '/construction/beauty/';
		} else {
			homeUrl = protocol + '//' + host + '/beauty/';
		}
		return homeUrl;
	}
}
